import { Expose, Type } from "class-transformer";
import { ProductWithCmsDataAndQualificationDto } from "../../../../pages/ProductsListPage/dtos/product-with-cms-data-and-qualification/product-with-cms-data-and-qualification.dto";
import { IProductsApiResponseDto } from "./products-api-response.dto.interface";

export class ProductsApiResponseDto implements IProductsApiResponseDto {
  @Expose()
  @Type(() => ProductWithCmsDataAndQualificationDto)
  services!: ProductWithCmsDataAndQualificationDto[];
}
